import $ from 'jquery';

const smoothScroll = function () {
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
      .not('[data-anchor-link]')
    .click(function (event) {
      // On-page links
      scrollToHash(event, this);
    });
  $('[data-scroll-next]').click(function(e) {
    const target = $('.shopify-section').eq(2);
    if (target.length) {
      e.preventDefault();
      scroll(target);
    }
  })
}


const scrollToHash = function(event, _this) {
  console.log("SMOOTH");
  if (
    location.pathname.replace(/^\//, '') == _this.pathname.replace(/^\//, '')
    &&
    location.hostname == _this.hostname
  ) {
    // Figure out element to scroll to
    var target = $(_this.hash);
    target = target.length ? target : $('[name=' + _this.hash.slice(1) + ']');

    console.log(target[0].id);
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      scroll(target);
    }
  }
}

export function scroll(target) {
  var ofsetValue = target.offset().top;
  var adjustmentValue = 0;
  var delay = 1000;
  if (target[0].id == 'compare_products') {

    adjustmentValue = $('#see_compare').outerHeight(true) + target.outerHeight()  ;
    console.log(adjustmentValue);
    ofsetValue -= adjustmentValue;
    delay = 0;

    //ofsetValue = $("._popup").eq(0).offset().top - (2 * $("._popup").eq(0).outerHeight()) - target.outerHeight(true) - $('#see_compare').outerHeight(true);
  }

  const position = $('#see_compare').offset().top + $('#see_compare').outerHeight(true) + $("._popup").eq(0).outerHeight() - 20 - $(window).innerHeight();
  $('html, body').animate({
    scrollTop: position
  }, 0, function () {
    console.log("test value");
    // Callback after animation
  });
}

export default smoothScroll;